(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();

/*
function syncSwipers() {
  setTimeout(() => {
    window.productMediaSlider?.update?.();
    window.productThumbSlider?.update?.();

    // Force Swipers to realign indexes
    window.productMediaSlider?.slideTo?.(0, 0);
    window.productThumbSlider?.slideTo?.(0, 0);
  }, 50);
}

document.addEventListener("DOMContentLoaded", () => {
  function initColorImageFilter() {
    const colorInputs = document.querySelectorAll(
      '.product-parameters__variant input[type="radio"]'
    );
    if (!colorInputs.length) return;

    const mainImages = document.querySelectorAll('.product__media-item');
    const thumbs = document.querySelectorAll('.product__media-subitem');
    const allMedia = [...mainImages, ...thumbs];

    if (!allMedia.length) return;

    function showItem(item) {
      item.style.display = "";
    }

    function hideItem(item) {
      item.style.display = "none";
    }

    function filterImages(color) {
      const lc = color.toLowerCase();
      let hasMatch = false;

      allMedia.forEach(item => {
        const alt = (item.querySelector("img")?.alt || "").toLowerCase();
        if (alt.includes(lc)) hasMatch = true;
      });

      // No color images → show all
      if (!hasMatch) {
        allMedia.forEach(showItem);
        syncSwipers();
        return;
      }

      // Filter
      allMedia.forEach(item => {
        const alt = (item.querySelector("img")?.alt || "").toLowerCase();
        const isColor = alt.includes(lc);
        const isCommon = alt.trim() === "";
        (isColor || isCommon) ? showItem(item) : hideItem(item);
      });

      syncSwipers();
    }

    // initial trigger
    const checked = document.querySelector(
      '.product-parameters__variant input[type="radio"]:checked'
    );
    if (checked) filterImages(checked.value);

    colorInputs.forEach(input =>
      input.addEventListener("change", () => filterImages(input.value))
    );
  }

  new MutationObserver(initColorImageFilter)
    .observe(document.body, { childList: true, subtree: true });

  initColorImageFilter();
});
*/

function syncSwipers() {
  setTimeout(() => {
    window.productMediaSlider?.update?.();
    window.productThumbSlider?.update?.();

    // Force Swipers to realign indexes
    window.productMediaSlider?.slideTo?.(0, 0);
    window.productThumbSlider?.slideTo?.(0, 0);
  }, 50);
}

document.addEventListener("DOMContentLoaded", () => {
  function initColorImageFilter() {
    const colorInputs = document.querySelectorAll(
      '.product-form__input--radios input[type="radio"][name*="Color"]'
    );
    if (!colorInputs.length) return;

    // Select all media items from the new structure
    const mainImages = document.querySelectorAll('.product__media-item');
    const allMedia = [...mainImages];

    if (!allMedia.length) return;

    function showItem(item) {
      item.style.display = "";
    }

    function hideItem(item) {
      item.style.display = "none";
    }

    function filterImages(color) {
      const lc = color.toLowerCase();
      let hasMatch = false;

      allMedia.forEach(item => {
        const img = item.querySelector("img");
        const alt = (img?.alt || "").toLowerCase();
        if (alt.includes(lc)) hasMatch = true;
      });

      // No color images → show all
      if (!hasMatch) {
        allMedia.forEach(showItem);
        syncSwipers();
        return;
      }

      // Filter
      allMedia.forEach(item => {
        const img = item.querySelector("img");
        const alt = (img?.alt || "").toLowerCase();
        const isColor = alt.includes(lc);
        const isCommon = alt.trim() === "";
        (isColor || isCommon) ? showItem(item) : hideItem(item);
      });

      syncSwipers();
    }

    // Initial trigger
    const checked = document.querySelector(
      '.product-form__input--radios input[type="radio"][name*="Color"]:checked'
    );
    if (checked) filterImages(checked.value);

    colorInputs.forEach(input =>
      input.addEventListener("change", () => filterImages(input.value))
    );
  }

  new MutationObserver(initColorImageFilter)
    .observe(document.body, { childList: true, subtree: true });

  initColorImageFilter();
});